import { useNavigate } from 'react-router-dom';
import { Dispatch, SetStateAction, useState } from 'react'

import VideoPlayer from '../../Components/VideoPlayer/VideoPlayer';
import { ContainerButtonPlay } from '../../Utils/Button';
import { ContinuarVideo, RetrocederVideo } from './constants';
import { IAcelerador, IMes } from '../../Interfaces/IAceleradores';

import { grayPlayButton, logo } from '../../Shared/Images';
import LinkIcon from '@mui/icons-material/Link';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import atrasIcon from '../../../../Shared/Images/atras-icon.png';

import '../../Shared/css/Aceleradores/aceleradoresMobile.css'


interface Props {
  aceleradores: IAcelerador[]; 
  selectedAcelerador: IAcelerador | null;
  currentPosition: number;
  setCurrentPosition: Dispatch<SetStateAction<number>>;
  completarVideo: (acelerador: IAcelerador) => void;
  mesSelected: IMes;
  mesSelectedPosition: number;
  setMesSelectedPosition: Dispatch<SetStateAction<number>>;
  meses: IMes[];
  selectPreviousMonth: () => void;
  selectNextMonth: () => void;
  linkUrlPortadaMes: string;
}

const AceleradoresMobile = ({ 
  aceleradores,
  selectedAcelerador,
  currentPosition,
  setCurrentPosition,
  completarVideo,
  mesSelected,
  mesSelectedPosition,
  meses,
  selectPreviousMonth,
  selectNextMonth,
  linkUrlPortadaMes
}: Props) => {

  const navigate = useNavigate();
  const [mostrarVideo, setMostrarVideo] = useState<boolean>(false);

  return (
    <div className="acel-page">
      <div className="acel-content">

        {/* Logo */}
        <div className="acel-logo">
          <img src={logo} alt='Fit4 Logo' />
        </div>

        {/* Month Navigation */}
        <div className="acel-month-nav">
          <button
            className="acel-month-btn"
            onClick={selectPreviousMonth}
            title={mesSelectedPosition === 0 ? 'Salir' : 'Ver mes anterior'}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              {mesSelectedPosition === 0 ? (
                <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
              ) : (
                <polyline points="15 18 9 12 15 6" />
              )}
            </svg>
          </button>

          <span className="acel-month-label">
            {(mesSelected || mesSelected?.nivel || mesSelected?.mes) ? `${mesSelected?.nivel} · Mes ${mesSelected?.mes}` : 'Aceleradores'}
          </span>

          <button
            className="acel-month-btn"
            onClick={selectNextMonth}
            title={mesSelectedPosition === meses.length - 1 ? 'Salir' : 'Ver mes siguiente'}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              {mesSelectedPosition === meses.length - 1 ? (
                <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
              ) : (
                <polyline points="9 18 15 12 9 6" />
              )}
            </svg>
          </button>
        </div>

        {aceleradores && aceleradores.length > 0 && selectedAcelerador ? (
          <>
            {/* Video Title */}
            <div className="acel-video-title">
              <span className="acel-video-number">Acelerador {selectedAcelerador?.index + 1}</span>
              <span className="acel-video-name">{selectedAcelerador?.titulo || ''}</span>
            </div>

            {/* Video Player / Thumbnail */}
            <div className="acel-video-container">
              {!mostrarVideo ? (
                <div className="acel-thumbnail">
                  <div className="acel-play-overlay" onClick={() => setMostrarVideo(true)}>
                    <div className="acel-play-btn">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="#FFFFFF">
                        <path d="M8 5.14v14l11-7-11-7z"/>
                      </svg>
                    </div>
                  </div>
                  <img
                    width="100%"
                    height="100%"
                    src={selectedAcelerador?.portada}
                    alt="portada"
                    className="acel-thumbnail-img"
                  />
                </div>
              ) : (
                <VideoPlayer
                  url={selectedAcelerador?.vimeoID}
                  onEnded={() => completarVideo(selectedAcelerador)}
                />
              )}
            </div>

            {/* Completed Badge */}
            <button
              className="acel-complete-btn"
              onClick={() => completarVideo(selectedAcelerador)}
            >
              <CheckCircleOutlineIcon
                fontSize="small"
                sx={{
                  color: selectedAcelerador?.retoTr4inerVideoPorUsuarioID !== 0 ? '#22c55e' : '#ccc',
                }}
              />
              Completado
            </button>

            {/* Description */}
            {selectedAcelerador?.descripcion && (
              <div className="acel-description">
                {selectedAcelerador.videoRetoTr4inerID !== 14 ? (
                  <div dangerouslySetInnerHTML={{ __html: selectedAcelerador?.descripcion }} />
                ) : (
                  <div>
                    <p>
                      <b>Con esto será IMPOSIBLE fallar.</b>
                      <br/>
                      No se trata de entrenar fuerte y comer bien un par de veces y esperar milagros. Si no tienes un sistema para asegurarte de que avanzas cada día, te quedarás igual. En este video te enseño el
                      <b> método </b>
                      que hace que progresar esté GARANTIZADO.
                    </p>
                    <a
                      href="https://bonostr4iner.s3.us-east-2.amazonaws.com/calendario_fit4_2025_1.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="acel-download-link"
                    >
                      <LinkIcon fontSize="small" /> Descarga aquí el Sistema Visual
                    </a>
                  </div>
                )}
              </div>
            )}

            {/* Video list (horizontal pills) */}
            <div className="acel-video-list">
              {aceleradores.map((video, i: number) => (
                <button
                  key={i}
                  className={`acel-video-pill ${selectedAcelerador?.index === i ? 'acel-video-pill--active' : ''}`}
                  onClick={() => {
                    setMostrarVideo(false);
                    setCurrentPosition(i);
                  }}
                >
                  <span className="acel-pill-number">{i + 1}</span>
                  <span className="acel-pill-title">{video.titulo}</span>
                  {video.retoTr4inerVideoPorUsuarioID !== 0 && (
                    <CheckCircleOutlineIcon sx={{ fontSize: 16, color: '#22c55e' }} />
                  )}
                </button>
              ))}
            </div>

            {/* Navigation Buttons */}
            <div className="acel-nav-buttons">
              {currentPosition === 0 ? (
                <button
                  className="acel-nav-btn acel-nav-btn--exit"
                  onClick={() => navigate('/producto/2')}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6" />
                  </svg>
                  Salir
                </button>
              ) : (
                <button
                  className="acel-nav-btn"
                  disabled={currentPosition === 0}
                  onClick={() => RetrocederVideo(currentPosition, aceleradores, setCurrentPosition)}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6" />
                  </svg>
                  Anterior
                </button>
              )}

              <button
                className="acel-nav-btn acel-nav-btn--next"
                disabled={currentPosition + 1 === aceleradores.length}
                onClick={() => ContinuarVideo(currentPosition, aceleradores, setCurrentPosition)}
              >
                Siguiente
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </button>
            </div>
          </>
        ) : (
          <div className="acel-cover-image">
            <img
              width="100%"
              src={linkUrlPortadaMes}
              alt="portada"
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default AceleradoresMobile